import React, { useEffect, useState } from 'react';
import Link from 'next/link';

import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';

import { getSearchItems, sort_array } from '@vrw-guppy/react-vrw';

import MissionBadge from '@/components/MissionBadge';
import SortForm from '@/components/SortForm';
import { MissionReadResponse, RecoveryEvent } from '@/lib/models/mission';

export const MissionListItem = ({ item }: { item: MissionReadResponse }) => {
  return (
    <Card sx={{ my: 1, overflow: 'visible' }}>
      <CardActionArea
        component={Link}
        href={`/q/${item.type}/i/${item.pk}`}
        sx={{ display: 'flex', alignItems: 'stretch', overflow: 'visible', padding: 0 }}
      >
        <MissionBadge status={item.status} sx={{ flexShrink: 0 }}>
          <CardMedia
            component="img"
            image={item.image_url}
            alt={item.title}
            loading="lazy"
            sx={{ width: 90, minHeight: 120, height: "100%", objectFit: 'cover', display: 'block' }}
          />
        </MissionBadge>
        <CardContent sx={{ flex: 1, minWidth: 0, p: 1, pl: 2 }}>
          <Typography variant="subtitle1" component="div">
            {item.title}
          </Typography>
          <Typography component="span" variant="body2" color="text.primary">
            {item.datetime_format}
          </Typography>
          {item.overview && (
            <Typography variant="body2">{item.overview}</Typography>
          )}
          {Boolean(item.recovery_events?.length) && <Divider sx={{ my: 1 }} />}
          {item.recovery_events &&
            item.recovery_events.length > 0 &&
            item.recovery_events.map((ev: RecoveryEvent) => (
              <Typography
                key={`${ev.vehicle_name}-${ev.datetime}`}
                variant="body2"
              >
                {`${ev.vehicle_name} #${ev.reuse_num ?? '-'}`} | {ev.location}
              </Typography>
            ))}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

const App = ({ items: defaultItems }: { items: any[] }) => {
  const [items, setItems] = useState(defaultItems);
  const [sort, setSort] = useState('datetime');
  const [order, setOrder] = useState('asc');

  const handleSubmit = ({ sort, order }: { sort: string; order: string }) => {
    setSort(sort);
    setOrder(order);
  };

  useEffect(() => {
    let _items = sort_array(defaultItems, [sort]);
    if (order === 'desc') {
      _items.reverse();
    }
    setItems(_items);
  }, [defaultItems, sort, order]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid
          container
          xs={12}
          sx={{
            borderBottom: '1px solid #eee',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Grid xs={12} md={'auto'} py={1} pl={1}>
            <Typography>{defaultItems.length} 件が見つかりました。</Typography>
          </Grid>
          <Grid xs={12} md={8} pb={1} px={1}>
            <SortForm
              onSubmit={handleSubmit}
              keys={getSearchItems('mission')}
              defaultSort="datetime"
              defaultOrder="asc"
            />
          </Grid>
        </Grid>
        {items.map((item, i) => (
          <Grid
            item
            xs={12}
            md={6}
            key={`mission-list-${i}`}
            sx={{
              borderBottom: '1px solid #eee',
            }}
          >
            <MissionListItem item={item} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default App;
